export const environment = {
  production: true,
  apiMock: 'https://api-loyalty.icheck.vn',
  baseSellout: '/api/sellout/api',

  apiCoreOld: 'https://api.icheck.com.vn/api/v1',
  apiCore: 'https://seller.icheck.com.vn',
  apiCoreV2: 'https://seller.icheck.com.vn',

  apiLoyalty: 'https://seller.icheck.com.vn/api/business/sell/cms',
  apiPublicLoyalty: 'https://seller.icheck.com.vn/api/business/public/sell',
  apiNotPublicLoyalty: 'https://seller.icheck.com.vn/api/business/sell',
  urlImage: 'https://upload.icheck.vn/hi/',
  url_static_image: "http://icheckcdn.net/images/720x720",
  url_mkt: 'https://qr.icheck.vn/',
  openAppiCheck: 'https://icheck.page.link/home',
  urlWebapp: 'https://loyalty-webapp.sellout.vn/',
  basePath: '/portal',
  tracking_id_teko: 'da524b9f-878e-4daf-ba85-87b55ff3e6b3',
  QR_SLK: 'https://qrcheck.icheck.vn',
  uploadStream: 'https://upload.icheck.com.vn/upload/stream',
};
